import React, {useCallback, useState} from 'react';
import {Popover} from "antd";
import {ProfileCard} from "../../Card";

interface ProfilePopoverProps {
    userId: string
    imgURL: any
    children?: any
    name: any
}

export const ProfilePopover: React.FunctionComponent<ProfilePopoverProps> = (props) => {
    const [open, setOpen] = useState<boolean>(false);

    const onOpenChange = useCallback((open: boolean) => {
        setOpen(open);
    }, [])

    return (
        <Popover
            open={open}
            onOpenChange={onOpenChange}
            trigger={"hover"}
            content={<ProfileCard userId={props?.userId} imgURL={props?.imgURL} name={props?.name} visible={open}/>}
        >
            {props.children}
        </Popover>
    )
}